import React from 'react';
import ReactApexChart from 'react-apexcharts';

export default class ApexChart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            series: [
                {
                    name: props.name,
                    data: [...props.data],
                },
            ],
            options: {
                chart: {
                    height: 350,
                    type: 'line',
                    zoom: {
                        enabled: false,
                    },
                    toolbar: {
                        show: false,
                    },
                },
                dataLabels: {
                    enabled: true,
                    colors: [...props.lineColor],
                },
                stroke: {
                    curve: 'straight',
                    colors: [...props.lineColor],
                },
                title: {
                    text: props.title,
                    align: 'left',
                },
                grid: {
                    row: {
                        colors: [...props.colors],
                        opacity: 0.5,
                    },
                },
                xaxis: {
                    categories: [...props.label],
                },
            },
        };
    }

    render() {
        return (
            <div id="chart">
                <ReactApexChart options={this.state.options} series={this.state.series} type="line" height={350} />
            </div>
        );
    }
}
